// extracted by css-extract-rspack-plugin
export default {"step":"oZ7yhUFzMIYjZ7VQ","heading":"MMFXmGh7GHArE1lS","body":"GIufnlTJXWIoj_oK"};